import React, { createContext, useContext } from 'react'
import { ActivityPriceInfo } from './usePricePreview'

const PricePreviewContext = createContext<ActivityPriceInfo[]>([])

export const PricePreviewProvider = PricePreviewContext.Provider

export function useActivityPriceInfo(
  activityId: number,
  categoryId?: number,
): ActivityPriceInfo | undefined {
  const priceInfo = useContext(PricePreviewContext)
  return priceInfo.find(
    (info) =>
      (info.categoryId !== null && info.categoryId === categoryId) ||
      (info.categoryId === null && info.activityId === activityId),
  )
}
